// src/app/services/hoodApi.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './apiConfig';
import { IHood, IHoodParams, UpdatePayload } from '../models';

export const hoodApi = createApi({
  reducerPath: 'hoodApi',
  baseQuery,
  endpoints: (builder) => ({
    getHoodParams: builder.query<{ hood: IHoodParams }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/hoods/params/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
      transformResponse: (data: { hood: IHoodParams }) => {
        data.hood.mounting_plane = data.hood.mounting_plane.filter(
          (el) => el.id < 7
        );
        return data;
      },
    }),
    getHood: builder.query<IHood, number>({
      query: (id) => `/api/v1.0/ahu/hoods/${id}`,
    }),

    updateHood: builder.mutation<IHood, UpdatePayload<IHood>>({
      query: ({ id, body, signal }) => ({
        url: `/api/v1.0/ahu/hoods/${id}`,
        method: 'PATCH',
        body,
        signal,
      }),
    }),
  }),
});

export const {
  useLazyGetHoodQuery,
  useGetHoodParamsQuery,
  useGetHoodQuery,
  useUpdateHoodMutation,
} = hoodApi;
